/**
 * InstallSource Plugin (Android only)
 * Capacitor bridge to InstallSourcePlugin.java: which package installed this app.
 */

import { registerPlugin } from '@capacitor/core';

const InstallSource = registerPlugin('InstallSource');

export default InstallSource;
